// Utils
import { ImMNElement, MNElement } from '../elements/elementModelTypes';
import { isAnnotation, isColumn, isLine } from '../elements/utils/elementTypeUtils';

export const canBeAColumnChild = (el: MNElement | ImMNElement) => !isLine(el) && !isAnnotation(el) && !isColumn(el);
